import React from 'react';
import styled, { keyframes } from 'styled-components';

const StyledFooter = styled.div`
  color: ${({ theme }) => theme.colors.N50};
  padding-top: ${({ theme }) => theme.spacing.md};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
  text-align: center;
`;

// https://jarv.is/notes/css-waving-hand-emoji/
const wave = keyframes`
  0% { transform: scale(1) rotate(0.0deg); }
  10% { transform: scale(1.8) rotate(0.0deg); }
  20% { transform: scale(1.8) rotate(14.0deg); }  /* The following five values can be played with to make the waving more or less extreme */
  30% { transform: scale(1.8) rotate(-8.0deg); }
  40% { transform: scale(1.8) rotate(14.0deg); }
  50% { transform: scale(1.8) rotate(-4.0deg); }
  60% { transform: scale(1.8) rotate(10.0deg); }
  70% { transform: scale(1.8) rotate(0.0deg); }  /* Reset for the last half to pause */
  85% { transform: scale(1) rotate(0.0deg); }
  100% { transform: rotate(0.0deg); }
`;

const Emoji = styled.span`
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  transform-origin: 70% 70%;
  animation-name: ${wave};
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  animation-play-state: paused;
  display: inline-block;
`;

const Text = styled.div`
  display: inline-block;

  &:hover {
    ${Emoji} {
      animation-play-state: running;
    }
  }
`;

function Footer({ ...rest }) {
  return (
    <StyledFooter>
      <Text>
        <Emoji>👋</Emoji>
        2022, Anton
      </Text>
    </StyledFooter>
  );
}

export default Footer;
